<template>
  <Command
    v-if="
      mediaPlayer instanceof GuidedNavigationService &&
      mediaPlayer.state === MediaPlayerState.Stopped
    "
    @click="trigger"
  >
    <slot
      v-bind="{
        disabled: isStarting,
        icon: 'play_arrow',
        label: t('tts.controls.play'),
        toolTip: t('tts.controls.play'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, ref, Ref, toValue } from "vue";
import { useI18n } from "vue-i18n";

import { useNavigator } from "@/components/navigator";
import { GuidedNavigationService } from "@/services/guidedNavigation/GuidedNavigationService";
import type { EpubNavigatorContainer } from "@/components/navigator/NavigatorContainer.vue";
import MediaPlayer, { MediaPlayerState } from "@/services/media/player";

import Command from "../command";
import { Locator } from "@readium/shared";

const { t } = useI18n();

const navigator = useNavigator();
const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer>;

const isStarting = ref(false);

async function trigger() {
  try {
    isStarting.value = true;

    if (!(mediaPlayer.value instanceof GuidedNavigationService)) {
      throw new Error(
        "Media player is not an instance of GuidedNavigationService"
      );
    }

    // this typecast is safe: GuidedNavigation is only supported for EPUB
    const navigatorContainer = toValue(navigator) as EpubNavigatorContainer;
    const startingPoint =
      await navigatorContainer.getGuidedNavigationStartingPoint();
    if (startingPoint instanceof Locator) {
      await mediaPlayer.value.startAtLocator(startingPoint);
    } else {
      await mediaPlayer.value.startAtElement(
        startingPoint.href,
        startingPoint.elementID
      );
    }
  } finally {
    isStarting.value = false;
  }
}
</script>
